import { PurchaseOrderItem, Supplier, SupplierPrice } from "./purchase";
import { Requirement, RequirementItem } from "./requirement";
import { User } from "./user";


export enum QuotationRequestItemStatus {
  UN_READ = 1,
  READ,
  RESOLVE,
  REJECT
}

export interface QuotationRequestItem {
  id: string;
  logBookId: string; //not null
  requirementItemId: string; //not null
  supplierId: string; //not null
  count: string;
  priceId: string; //not null
  price: SupplierPrice;
  deadline: number | null; //最晚提交时间 not null
  mrd: number | null; // 预计交货时间 not null
  status: QuotationRequestItemStatus; // 问询单状态 未读、已读、已提交、已拒绝
  submitBy: string;
  submitAt: number | null;
  supplierPrice: string; //nullable 供应商提供的价格
  supplierTime: number | null; //nullable 供应商提供的到货时间
  requirementItem: RequirementItem;
  user: User;
  supplier: Supplier;
  creator: User;
  updater: User;
  submiter: User;
  mpq: number | null; // 最小包装
  days: number | null; // 供货周期
  purchaseItem: PurchaseOrderItem,
  remark: string;
  spareCount?: number;
}